import { useEffect, useRef } from 'react';

export const useScrollListener = () => {
    const scrollRef = useRef({
        x: 0,
        y: 0,
        lastX: 0,
        lastY: 0
    });

    useEffect(() => {
        const handleScroll = () => {
            const { x, y } = scrollRef.current;
            scrollRef.current = {
                x: window.scrollX,
                y: window.scrollY,
                lastX: x,
                lastY: y
            };

            const scroll = scrollRef.current;
            const header = window.document.getElementById('header');
            if (!header) { return; }

            if (scroll.y > 150 && scroll.y - scroll.lastY > 0) {
                header.classList.remove('sticky');
            } else {
                header.classList.add('sticky');
            }
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
};
